import { downloadingDocSubmissionMyResponseDetailFile } from '../simple-action';
import { downloadNewDocumentMyResponseFile } from '../../../helper';

export default file => async (dispatch, getState) => {
  const { token } = getState().authentication;
  try {
    dispatch(downloadingDocSubmissionMyResponseDetailFile(true));
    const downloadedFile = await downloadNewDocumentMyResponseFile(token, file);
    return downloadedFile.content;
  } finally {
    dispatch(downloadingDocSubmissionMyResponseDetailFile(false));
  }
};
